import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgTwitterLogo32WhiteBg = props => _jsxs("svg", _objectSpread(_objectSpread({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [_jsx("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#fff"
  }), _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.072 24.44c7.096 0 10.976-5.88 10.976-10.976 0-.168 0-.336-.008-.496a7.903 7.903 0 0 0 1.928-2 7.83 7.83 0 0 1-2.216.608 3.855 3.855 0 0 0 1.696-2.136c-.744.44-1.568.76-2.448.936a3.84 3.84 0 0 0-2.816-1.216 3.858 3.858 0 0 0-3.856 3.856c0 .304.032.6.104.88A10.944 10.944 0 0 1 8.48 9.864a3.87 3.87 0 0 0-.52 1.936c0 1.336.68 2.52 1.72 3.208a3.79 3.79 0 0 1-1.744-.48v.048a3.862 3.862 0 0 0 3.096 3.784 3.846 3.846 0 0 1-1.744.064 3.852 3.852 0 0 0 3.6 2.68 7.755 7.755 0 0 1-5.712 1.592 10.748 10.748 0 0 0 5.896 1.744Z",
    fill: props.color || "#58595B"
  })]
}));
export default SvgTwitterLogo32WhiteBg;